/** One labelled stat cell (label over value, optional muted suffix). Shared by the
 * forecast candidate stats and the campaign page owner stats. */
export function Stat({ label, value, sub }: { label: string; value: string | number; sub?: string }) {
  return (
    <div>
      <div className="text-[11px] uppercase tracking-wide text-muted">{label}</div>
      <div className="font-semibold tabular-nums">
        {value} {sub && <span className="text-xs text-muted font-normal">{sub}</span>}
      </div>
    </div>
  );
}
